import React from 'react'
import styled from 'styled-components'
import {SidebarItem} from '../styled-components/components'

const StyledActionGroup = styled(SidebarItem)`
    font-weight:bold;
`


const ActionGroup = ({name}) => (
    <StyledActionGroup>{name}</StyledActionGroup>
)

export default ActionGroup